module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Book-46f098b6a5c9e8190f6580bc6d67a064.svg";